module.exports = __webpack_public_path__ + "img/钢铁行业结构示意图.d1cecd28.jpg";